import React from 'react';
import newsData from '../news.json';
import './News.css';

// Content is edited in src/news.json
const NEWS_ITEMS = newsData.items;

function News() {
  return (
    <div className="page news-page">
      <div className="container-narrow">
        <header className="page-header">
          <h1>News &amp; Media</h1>
          <p className="subtitle">
            Coverage, interviews, and media featuring our team and research.
          </p>
          <div className="accent-bar"></div>
        </header>

        <div className="news-grid">
          {NEWS_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="news-card"
            >
              <span className={`news-type news-type-${item.type.toLowerCase()}`}>{item.type}</span>
              <h3 className="news-title">{item.title}</h3>
              <p className="news-source">{item.source}</p>
              <span className="news-link">
                Read more
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default News;